import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DeviceMeta } from 'Roblox';
import SubscriptionCard from '../components/SubscriptionCard';
import PremiumService from '../services/premiumService';

const { isInApp } = DeviceMeta();

function SubscriptionCardContainer({ translate, intl, planInfo }) {
  const [userPlan, setUserPlan] = useState(null);

  useEffect(() => {
    PremiumService.getUserPremiumStatus().then(
      response => {
        setUserPlan(response.data?.subscriptionProductModel);
      },
      ({ data }) => {
        console.log(data.errorMessage);
      }
    );
  }, []);

  const userPlanStatusText = () => {
    if (userPlan) {
      const membershipName = translate(
        PremiumService.getMembershipNameLocaleKey(userPlan.subscriptionTypeName)
      );

      const dateTimeFormatter = intl.getDateTimeFormatter();
      if (userPlan.renewal) {
        return translate('Label.MembershipStatusRecurring', {
          premiumSubscription: membershipName,
          renewal: dateTimeFormatter.getShortDate(new Date(userPlan.renewal), 'short')
        });
      }
      if (userPlan.expiration) {
        return translate('Label.MembershipStatusExpiration', {
          premiumSubscription: membershipName,
          expirationDate: dateTimeFormatter.getShortDate(new Date(userPlan.expiration), 'short')
        });
      }
    }
    return '';
  };
  const legalText = !isInApp
    ? translate('Description.legalDisclosuresPremiumUpgradePageV3', {
        termsLinkStart: `<a href=${PremiumService.getTermsPageUrl()} class="text-link" target="_blank">`,
        termsLinkEnd: '</a>',
        privacyLinkStart: `<a href=${PremiumService.getPrivacyPageUrl()} class="text-link" target="_blank">`,
        privatyLinkEnd: '</a>',
        billingLinkStart: `<a href=${PremiumService.getBillingSettingUrl()} class="text-link" target="_blank">"`,
        billingLinkEnd: '</a>'
      })
    : '';

  return (
    <div className='membership-section' id='premium-memberships'>
      <div className='membership-sec-header'>
        <div className='font-title'>{translate('Heading.YourPremium')}</div>
      </div>
      {userPlan && (
        <div
          className='font-header-1 subscription-note'
          dangerouslySetInnerHTML={{
            __html: userPlanStatusText()
          }}
        />
      )}
      {planInfo && (
        <div className='three-subs'>
          <div className='div-table subscriptions-containers'>
            <div className='div-table-row'>
              {planInfo.map(plan => {
                if (userPlan) {
                  return (
                    <SubscriptionCard
                      translate={translate}
                      intl={intl}
                      planInfo={plan}
                      userPlan={userPlan}
                    />
                  );
                }
                return <SubscriptionCard translate={translate} intl={intl} planInfo={plan} />;
              })}
            </div>
          </div>
        </div>
      )}
      <div className='benefits-detail-container'>
        <div className='characters lucky-gatito' />
        <div className='div-table'>
          <div className='div-table-row perk'>
            <div className='div-table-cell'>
              <span className='icon-menu-games-on perk-icon' />
            </div>
            <div className='div-table-cell perk-desc'>
              {translate('Description.AccessPremiumGame')}
            </div>
          </div>
          <div className='div-table-row perk'>
            <div className='div-table-cell'>
              <span className='icon-menu-shop perk-icon' />
            </div>
            <div className='div-table-cell perk-desc'>
              {translate('Description.AccessPremiumItems')}
            </div>
          </div>
          <div className='div-table-row perk'>
            <div className='div-table-cell'>
              <span className='icon-robux-28x28 perk-icon' />
            </div>
            <div className='div-table-cell perk-desc'>
              {translate('Description.RobuxExtra', { extra: 10 })}
            </div>
          </div>
          <div className='div-table-row perk'>
            <div className='div-table-cell'>
              <span className='icon-menu-trade perk-icon' />
            </div>
            <div className='div-table-cell perk-desc'>{translate('Description.TradeBenefit')}</div>
          </div>
        </div>
      </div>
      {!isInApp && (
        <p
          className='text-footer legal-text-holder'
          dangerouslySetInnerHTML={{ __html: legalText }}
        />
      )}
    </div>
  );
}

SubscriptionCardContainer.propTypes = {
  translate: PropTypes.func.isRequired,
  intl: PropTypes.func.isRequired,
  planInfo: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.number.isRequired,
      premiumFeatureId: PropTypes.number.isRequired,
      isRecurring: PropTypes.bool.isRequired,
      robuxAmount: PropTypes.string.isRequired,
      price: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        currency: PropTypes.shape({
          currencySymbol: PropTypes.string.isRequired
        }).isRequired
      }).isRequired
    })
  ).isRequired
};

export default SubscriptionCardContainer;
